export default __webpack_public_path__ + "static/media/LOGOYTEXTO.8d05276b.svg";